export default class Produtos {
    constructor(_id, xProd, cProd, NCM, uCom, CFOP, cEAN, prodRastro, fornCnpj, fornRazao, dtReg, fornId, customValues, conta, nfes) {

        // this.emissao = ,
        // this.emissao = emissao.substring(0, emissao.indexOf("T")).split('-').reverse().join('/'),
        this.xProd = xProd != undefined ? xProd.toLocaleUpperCase() : '',
            this.cProd = cProd != undefined ? cProd.toLocaleUpperCase() : '',
            this.NCM = NCM != undefined ? NCM.toLocaleUpperCase() : '',
            this.uCom = uCom != undefined ? uCom.toLocaleUpperCase() : '',
            this.CFOP = CFOP != undefined ? CFOP.toLocaleUpperCase() : '',
            this.cEAN = cEAN != undefined ? cEAN.toLocaleUpperCase() : '',
            this.prodRastro = prodRastro;
            this.dtReg = new Date(dtReg);
            this.fornCnpj = fornCnpj != undefined ? fornCnpj.toLocaleUpperCase() : '',
            this.fornRazao = fornRazao != undefined ? fornRazao.toLocaleUpperCase() : '',
            this.fornId = fornId != undefined ? fornId.toLocaleUpperCase() : '',
            this._id = _id,
            this.customValues = customValues,
            this.conta = conta != undefined ? conta.toLocaleUpperCase() : '',
            this.nfes = nfes
    }
}





// WEBPACK FOOTER //
// ./src/domain/produtos/Produtos.js